/**
 * Typography, spacing, radius and shadow tokens.
 * Font stacks honour Clarivate brand portal (Regular Clarivate, Albert Sans fallback).
 */

export const typography = {
  fontFamily: {
    sans: "'Regular Clarivate', 'Albert Sans', Arial, sans-serif",
    mono: "'JetBrains Mono', 'SF Mono', Menlo, monospace",
  },
  size: {
    xs: 11,
    sm: 12,
    base: 14,
    md: 15,
    lg: 16,
    xl: 18,
    '2xl': 22,
    '3xl': 28,
    '4xl': 36,
  },
  weight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
  lineHeight: { tight: 1.2, snug: 1.35, normal: 1.5, relaxed: 1.65 },
} as const;

/** 4px base grid */
export const spacing = (n: number) => `${n * 4}px`;

export const radius = {
  xs: 4,
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 20,
  full: 9999,
} as const;

export const shadow = {
  none: 'none',
  sm: '0 1px 2px 0 rgba(16,24,40,0.04)',
  md: '0 2px 4px -1px rgba(16,24,40,0.06), 0 4px 8px -2px rgba(16,24,40,0.08)',
  lg: '0 8px 16px -4px rgba(16,24,40,0.08), 0 12px 24px -6px rgba(16,24,40,0.10)',
} as const;
